/*eslint-disable*/
import { useState } from "react";
import { useNavigate } from "react-router-dom";

import ReactQuill from 'react-quill';

import RoadmapActivity from '../../RoadmapActivity';
import UpvoteComponent from '../../../common/roadmap/SingleItem/UpvoteComponent';
import DetailsSidebar from './DetailsSidebar';
import PageBack from '../../../common/PageBack';
import WithBillingDetails from '../../../common/hoc/WithBillingDetails';

import {
    Row,
    Col,
    Button,
    Input,
    Form,
    Alert,
    FormGroup,
    Label,
    Spinner,
} from "reactstrap";
import './public-details.scss';

const RoadmapDetailComponent = ({
    type,
    upvoteHandler,
    saveRoadmap,
    submitComment,
    saveCommentsLoader,
    commentsAlert,
    roadmapInfo,
    comentsUpvote,
    commentsInfo,
    setcommentsInfo,
    billingDetails,
}) => {
    const navigate = useNavigate();
    const [roadmapPayload, setRoadmapPayload] = useState({});

    const roadmapSave = () => {
        // write code to save roadmapPayload
        saveRoadmap(roadmapPayload, true);
    };

    const getAvatar = (user) => {
        return (
            user[0].toUpperCase()
        )
    };

    const goBackFeatureRequests = () => {
        navigate('/feature_requests');
    };

    return (
        <div className="roadmap-details-container">
            <div className="roadmap-details ">
                {
                    roadmapInfo.title.length === 0 && (
                        <div className="details-spinner">
                            <Spinner className="save-comment">Saving..</Spinner>
                        </div>
                    )
                }
                <PageBack backHandler={goBackFeatureRequests} backText="Back to Feature Requests" />

                <div className="public-roadmap-title-row __row">
                    <div style={{ paddingLeft: 0, paddingRight: 0 }}>
                        <UpvoteComponent
                            upvoteHandler={upvoteHandler}
                            roadmap={roadmapInfo}
                            roadmapDetails={true}
                        />
                    </div>
                    <div style={{ paddingRight: 0, paddingLeft: 0, }}>
                        <h1 className="public-roadmap-title">{roadmapInfo?.title}</h1>
                        <div className="public-roadmap-content-wrapper" style={{ fontSize: '15px' }}>
                            {
                                roadmapInfo?.htmlDescription?.length > 0 ? (
                                    <ReactQuill
                                        theme="bubble"
                                        className="public-roadmap-content"
                                        placeholder="Changelog description"
                                        value={roadmapInfo?.htmlDescription}
                                        readOnly={true}
                                        modules={{ "toolbar": null }}
                                        bounds={`#__quill-tool`}
                                    />
                                ) : (
                                    <p>{roadmapInfo?.description}</p>
                                )
                            }
                            {/* {parse(roadmapInfo?.description)} */}

                        </div>
                    </div>
                </div>

                <Row className="__row">
                    <Col md='9' className="__details" >

                        {/* comments */}
                        <div className="events">
                            <p className="__label"></p>
                            <Form>
                                <FormGroup floating>
                                    <Input
                                        id="comments-input"
                                        name="text"
                                        type="textarea"
                                        height="40"
                                        className="comments-input"
                                        placeholder="Leave a comment"
                                        value={commentsInfo.value}
                                        onChange={(event) => setcommentsInfo({ ...commentsInfo, value: event.target.value })}
                                    />
                                    <Label for="comments-input">
                                        Comments
                                    </Label>
                                </FormGroup>
                            </Form>
                            {
                                commentsInfo.value.length > 0 && (
                                    <Button
                                        className="comment-submit"
                                        disabled={(commentsInfo.value.length == 0) || saveCommentsLoader.show}
                                        onClick={() => submitComment(commentsInfo, true)}>
                                        {
                                            saveCommentsLoader.show && (
                                                <Spinner size="sm" style={{ marginRight: '4x' }} />
                                            )
                                        }
                                        Submit
                                    </Button>
                                )
                            }
                            {
                                commentsAlert.show && (
                                    <Alert color={commentsAlert.type} style={{ marginTop: '10px', padding: '8px', width: 'fit-content', fontSize: '14px' }}>
                                        {commentsAlert.text}
                                    </Alert>
                                )
                            }

                            {
                                roadmapInfo?.activity?.length > 0 && (
                                    <div className="all-activity">
                                        <RoadmapActivity
                                            activities={roadmapInfo?.activity}
                                            comentsUpvote={comentsUpvote}
                                        />
                                    </div>
                                )
                            }

                        </div>
                    </Col>
                    <Col md='3' className="details-section">
                        <DetailsSidebar
                            billingDetails={billingDetails}
                            roadmapInfo={roadmapInfo}
                        />
                    </Col>
                </Row>
            </div>

            <div>
                {
                    type !== 'public' && (
                        <>
                            <Button color="primary" onClick={roadmapSave}>
                                Save
                            </Button>{' '}
                        </>
                    )
                }

                {/* <Button color="secondary" onClick={roadmapToggle}>
                    Cancel
                </Button> */}
            </div>
        </div>
    );
};

export default WithBillingDetails(RoadmapDetailComponent);
